import React, { memo, useEffect } from "react";
import styles from "./SolarRecommendationFinalization.module.scss";
import PreviewSection from "./components/preview-section/PreviewSection";
import { useNavigate } from "react-router-dom";
import { SolarRecommendationForm } from "../../../model/solar-recommendation-form/solar-recommendation-form";
import { ApplicationRoutes } from "../../../routes";
import { AppDispatch } from "../../../stores/store";
import { useDispatch } from "react-redux";
import { init, recommendProducts } from "../../../stores/slices/solar-recommendation-slice";
import { toast } from "react-toastify";
import { hideLoader, showLoader } from "../../../stores/slices/loader-slice";
type Props = {
  onBack: () => void
};

const SolarRecommendationFinalization: React.FC<Props> = memo((props: Props) => {
	const formFromStorage = sessionStorage.getItem("solar-recommendation-form");

	const parsedForm: SolarRecommendationForm | undefined = formFromStorage ? JSON.parse(formFromStorage) : undefined;

	const navigate = useNavigate();

	const dispatch = useDispatch<AppDispatch>();

	const returnToEditing = () => {
    props?.onBack()
		// navigate(ApplicationRoutes.RECOMMENDATION);
	};

	const recommend = async () => {
		try {
			dispatch(showLoader());

			const result = await dispatch(
				recommendProducts({
					page: 1,
					pageSize: 6,
				})
			);

			if (recommendProducts.fulfilled.match(result)) {
				navigate(`/${ApplicationRoutes.RECOMMENDATION_OVERVIEW}`);
			} else {
				toast.error("There was an error recommending the products");
			}
		} finally {
			dispatch(hideLoader());
		}
	};

	useEffect(() => {
		dispatch(init());
	}, [dispatch]);

	return (
		<div className={styles.container}>
			<div className={styles.innerContainer}>
				<div className={styles.title}>Confirm Your Informations</div>
				<div className={styles.infoContainer}>
					<PreviewSection form={parsedForm} showDividerUnderTitle={true} />
				</div>
				<div className={styles.buttonContainer}>
					<button className={`standardButton ${styles.button} ${styles.backToEditingbutton}`} onClick={returnToEditing}>
						<svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M2.55335 6.00047L6.62642 1.92737C6.76489 1.78892 6.83572 1.61489 6.83892 1.40527C6.84214 1.19568 6.77131 1.01844 6.62642 0.873575C6.48156 0.728692 6.30592 0.65625 6.09952 0.65625C5.89312 0.65625 5.71749 0.728692 5.57262 0.873575L1.0784 5.3678C0.9848 5.46138 0.918774 5.5601 0.880324 5.66395C0.841858 5.76778 0.822625 5.87996 0.822625 6.00047C0.822625 6.12099 0.841858 6.23317 0.880324 6.337C0.918774 6.44085 0.9848 6.53957 1.0784 6.63315L5.57262 11.1274C5.71107 11.2658 5.88511 11.3367 6.09473 11.3399C6.30432 11.3431 6.48156 11.2723 6.62642 11.1274C6.77131 10.9825 6.84375 10.8069 6.84375 10.6005C6.84375 10.3941 6.77131 10.2184 6.62642 10.0736L2.55335 6.00047Z"
								fill="var(--app-status-pending)"
							/>
						</svg>
						Back to editing
					</button>
					<button className={`standardButton ${styles.button} ${styles.confirmButton}`} onClick={recommend}>
						Confirm
						<svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M4.94665 6.00047L0.873576 1.92737C0.735109 1.78892 0.664276 1.61489 0.661076 1.40527C0.657859 1.19568 0.728692 1.01844 0.873576 0.873575C1.01844 0.728692 1.19408 0.65625 1.40048 0.65625C1.60688 0.65625 1.78251 0.728692 1.92738 0.873575L6.4216 5.3678C6.5152 5.46138 6.58123 5.5601 6.61968 5.66395C6.65814 5.76778 6.67738 5.87996 6.67738 6.00047C6.67738 6.12099 6.65814 6.23317 6.61968 6.337C6.58123 6.44085 6.5152 6.53957 6.4216 6.63315L1.92738 11.1274C1.78893 11.2658 1.61489 11.3367 1.40527 11.3399C1.19568 11.3431 1.01844 11.2723 0.873576 11.1274C0.728692 10.9825 0.65625 10.8069 0.65625 10.6005C0.65625 10.3941 0.728692 10.2184 0.873576 10.0736L4.94665 6.00047Z"
								fill="white"
							/>
						</svg>
					</button>
				</div>
			</div>
		</div>
	);
});

export default SolarRecommendationFinalization;
